import {
  ErrorDefault,
  RequestDefault,
  ResponseDefault,
} from "../../shared/constant";
import trackConstants from "../constants/trackConstants";

const initialState: {
  tracks: any[];
  tracksResponse: any;
  tablePending: Boolean;
  allTracks: any[];
  error: Boolean;
  pending: Boolean;
  fulfilled: Boolean;
  allTracksLoading: Boolean;
  downloadedTracksInCSVResponse: any;
  downloadTracksInCSVPending: Boolean;

  tracksIncomeSummary: any;
  tracksIncomeSummaryError: Boolean;
  tracksIncomeSummaryPending: Boolean;
  tracksIncomeSummaryFulfilled: Boolean;
} = {
  tracks: [],
  tracksResponse: null,
  allTracks: [],
  error: false,
  pending: false,
  fulfilled: false,
  tablePending: false,
  allTracksLoading: false,
  downloadedTracksInCSVResponse: null,
  downloadTracksInCSVPending: false,

  tracksIncomeSummary: null,
  tracksIncomeSummaryError: false,
  tracksIncomeSummaryPending: false,
  tracksIncomeSummaryFulfilled: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case trackConstants.GET_TRACKS_LIST:
      return {
        ...state,
        tablePending: true,
      };
    case trackConstants.GET_TRACKS_LIST_SUCCESS:
      return {
        ...state,
        tracks: action.payload.data.results,
        tracksResponse: action.payload.data,
        tablePending: false,
      };
    case trackConstants.GET_TRACKS_LIST_FAILURE:
      return {
        ...state,
        tablePending: false,
      };
    case trackConstants.GET_ALL_TRACKS_REQUEST:
      return {
        ...state,
        allTracksLoading: true,
      };
    case trackConstants.GET_ALL_TRACKS_SUCCESS:
      return {
        ...state,
        allTracks: action.payload.data,
        allTracksLoading: false,
      };
    case trackConstants.GET_ALL_TRACKS_FAILURE:
      return {
        ...state,
        allTracksLoading: false,
      };

    case trackConstants.GET_TRACKS_INCOME_SUMMARY_REQUEST:
      return {
        ...state,
        tracksIncomeSummaryError: false,
        tracksIncomeSummaryPending: true,
        tracksIncomeSummaryFulfilled: false,
      };
    case trackConstants.GET_TRACKS_INCOME_SUMMARY_SUCCESS:
      return {
        ...state,
        tracksIncomeSummary: action.payload.data,
        tracksIncomeSummaryError: false,
        tracksIncomeSummaryPending: false,
        tracksIncomeSummaryFulfilled: true,
      };
    case trackConstants.GET_TRACKS_INCOME_SUMMARY_FAILURE:
      return {
        ...state,
        tracksIncomeSummaryError: true,
        tracksIncomeSummaryPending: false,
        tracksIncomeSummaryFulfilled: false,
      };

    case trackConstants.DOWNLOAD_TRACKS_IN_CSV_REQUEST:
      return {
        ...state,
        downloadTracksInCSVPending: true,
      };
    case trackConstants.DOWNLOAD_TRACKS_IN_CSV_SUCCESS:
      return {
        ...state,
        downloadedTracksInCSVResponse: action.payload.data,
        downloadTracksInCSVPending: false,
      };
    case trackConstants.DOWNLOAD_TRACKS_IN_CSV_FAILURE:
      return {
        ...state,
        downloadTracksInCSVPending: false,
      };

    case trackConstants.CREATE_TRACK_REQUEST:
    case trackConstants.EDIT_TRACK_REQUEST:
    case trackConstants.DELETE_TRACK_REQUEST:
      return {
        ...state,
        ...RequestDefault,
      };
    case trackConstants.CREATE_TRACK_SUCCESS:
    case trackConstants.EDIT_TRACK_SUCCESS:
    case trackConstants.DELETE_TRACK_SUCCESS:
      return {
        ...state,
        ...ResponseDefault,
      };
    case trackConstants.CREATE_TRACK_FAILURE:
    case trackConstants.EDIT_TRACK_FAILURE:
    case trackConstants.DELETE_TRACK_FAILURE:
      return {
        ...state,
        ...ErrorDefault,
      };
    case trackConstants.RESET_TRACKS:
      return {
        ...state,
        tracks: [],
        tracksResponse: null,
        allTracks: [],
      };
    case trackConstants.RESET_DOWNLOAD_TRACKS_IN_CSV:
      return {
        ...state,
        downloadedTracksInCSVResponse: null,
      };
    default:
      return {
        ...state,
      };
  }
};
